import React, { useState, useEffect } from "react";
import Alert from "../../components/Alert";
import Breadcrumb from "../../parts/Breadcrumb";
import { Link, useHistory } from "react-router-dom";
import { pluck } from "underscore";
import ListSection from "../../components/ListSection";
import labels from "../../constants/RatingCriterias";
import configuration from "../../config";
import { toast } from "react-toastify";
import DeleteModel from "../../components/DeleteModel";
import { getAccessRights } from "../../utils/common";
import Loader from "../../components/Loader/Loader";

// List all roles
function View({ location }) {
  const [accessRights, setAccessRights] = useState();
  const [isLoader, setIsLoader] = useState(false);

  const columns = [
    {
      title: "ID",
      field: "id",
      render: (rowData) =>
        accessRights?.edit ? (
          <Link
            className="text-indigo-600 hover:text-indigo-900"
            to={`/rating-criterias/edit/${rowData.rating_criteria_id}`}
          >
            {rowData.rating_criteria_id}
          </Link>
        ) : (
          rowData.rating_criteria_id
        ),
    },
    { title: "Title", field: "title" },
    {
      title: "User Type",
      field: "user_type",
      render: (rowData) => (
        <span className="capitalize">{rowData.user_type}</span>
      ),
    },
    {
      title: "Status",
      field: "status",
      render: (rowData) => (
        <span
          className={
            rowData.status === "active"
              ? "inline-flex items-center px-3 py-0.5 rounded-full text-basefont-medium bg-green-100 text-green-800"
              : "inline-flex items-center px-3 py-0.5 rounded-full text-basefont-medium bg-red-100 text-red-800"
          }
        >
          {" "}
          {rowData.status === "active" ? "Active" : "Inactive"}
        </span>
      ),
    },
  ];

  const btnGroups = [
    {
      id: 1,
      title: "Add New",
      type: "addNew",
      path: "/rating-criterias/add",
      key: "add",
    },
    {
      id: 2,
      title: "Make Active",
      type: "makeActive",
      path: "/rating-criterias",
      key: "edit",
    },
    {
      id: 3,
      title: "Make Inactive",
      type: "makeInactive",
      path: "/rating-criterias",
      key: "edit",
    },
    {
      id: 5,
      title: "Delete",
      type: "delete",
      path: "/rating-criterias",
      key: "delete",
    },
  ].filter((btn) => accessRights?.[btn.key]);

  const [show, setShow] = useState(false);
  const [data, setData] = useState([]);
  const [ids, setIds] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const history = useHistory();

  useEffect(() => {
    getAccessRights().then((rights) => {
      const rightsData = rights?.find((ac) => ac.code === "RATING_CRITERIAS");
      setAccessRights(rightsData);
      if (rightsData?.view === false) {
        history.push("/dashboard");
      }
    });

    getDatas();
  }, [location.state]);

  function getDatas() {
    setIsLoader(true);
    configuration
      .getAPI({ url: "rating-criterias/list", params: {} })
      .then((data) => {
        setIsLoader(false);
        if (data.status === 200) {
          setData(data.payload);
        }
      })
      .catch((error) => {
        setIsLoader(false);
        return toast.error(error.message);
      });
  }
  function handleAction(type) {
    if (ids.length < 1) {
      return toast.error("Please select at least one record");
    } else if (type === "delete") {
      setShowModal(true);
      return;
    }
    setIsLoader(true);
    const sendData = {
      ids,
      type:
        type === "makeActive"
          ? "active"
          : type === "makeInactive"
          ? "inactive"
          : type,
    };
    configuration
      .postAPI({ url: "rating-criterias/action", params: sendData })
      .then((data) => {
        setIsLoader(false);
        if (data.status === 200) {
          getDatas();
          setIds([]);
          return toast.success(
            type === "delete"
              ? "Record deleted successfully"
              : "Record updated successfully"
          );
        } else if (data.error) {
          return toast.error(data.error.message);
        } else {
          return toast.error("Something went wrong");
        }
      })
      .catch((error) => {
        setIsLoader(false);
        return toast.error(error.message);
      });
  }
  const onSelectionChange = (e) => {
    let idArr = pluck(e, "rating_criteria_id");
    setIds(idArr);
  };
  function handleDelete() {
    setShowModal(false);
    setIsLoader(true);
    const sendData = {
      ids,
      type: "delete",
    };
    configuration
      .postAPI({ url: "rating-criterias/action", params: sendData })
      .then((data) => {
        setIsLoader(false);
        if (data.status === 200) {
          getDatas();
          setIds([]);
          setShowModal(false);
          return toast.success("Record deleted successfully");
        } else if (data.error) {
          return toast.error(data.error.message);
        } else {
          return toast.error("Something went wrong");
        }
      })
      .catch((error) => {
        setIsLoader(false);
        return toast.error(error.message);
      });
  }
  function handleCancel() {
    setShowModal(false);
  }
  return (
    <>
      {isLoader ? <Loader /> : ""}
      <Breadcrumb module={labels.RatingCriterias} />
      <DeleteModel
        mode={showModal}
        handleDelete={handleDelete}
        handleCancel={handleCancel}
      />

      <ListSection
        captionTitle="Rating Criterias"
        columns={columns}
        data={data}
        btnGroups={btnGroups}
        handleAction={handleAction}
        onSelectionChange={onSelectionChange}
      />
    </>
  );
}

export default View;
